const config = {
  auth: {
    accessTokenValidity: Number(process.env.REACT_APP_ACCESS_TOKEN_MIN_VALIDITY_SECS) || 30,
    authProvider: process.env.REACT_APP_AUTH_PROVIDER || 'KEYCLOAK',
    clientId: process.env.REACT_APP_OAUTH2_CLIENT_ID,
    realm: process.env.REACT_APP_OAUTH2_REALM,
    url: process.env.REACT_APP_OAUTH2_API_URL
  },
  backend: {
    url: process.env.REACT_APP_API_URL
  },
  controlCentre: {
    url: process.env.REACT_APP_FRONTEND_HOME_URI
  },
  coreService: {
    url: process.env.REACT_APP_CORE_API_URL
  },
  customerProfile: {
    url: process.env.REACT_APP_CUSTOMER_PROFILE_API_URL
  },
  datadog: {
    applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID || 'dummy-app-id',
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN || 'dummy-client-token',
    enabled: process.env.REACT_APP_DATADOG_RUM_ENABLED === 'true',
    env: process.env.REACT_APP_CHECKIT_ENV || 'LOCAL',
    service: 'work-management-app',
    site: 'datadoghq.com'
  },
  gitBranch: process.env.REACT_APP_BRANCH_NAME || 'branch-name',
  gitCommit: process.env.REACT_APP_GIT_COMMIT || 'commit-id',
  help: {
    url: process.env.REACT_APP_HELP_URL || 'https://www.checkit.net/help'
  },
  sharedParams: {
    defaultDebounceTime: 350
  },
  version: process.env.REACT_APP_VERSION,
  workManagement: {
    showCheckboxFeature: process.env.REACT_APP_CHECKBOX_FEATURE || false,
    showLibraryRulePanel: process.env.REACT_APP_LIBRARY_RULE_PANEL === 'true',
    showLibrarySchedulePanel: process.env.REACT_APP_LIBRARY_SCHEDULE_PANEL === 'true',
    url: process.env.REACT_APP_WORK_MANAGEMENT_API_URL
  }
};

export default config;
